import $api from "@/shared/http";
import $integrationApi from "@/shared/http/integration";
import { toApiError } from "@/shared/http/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  DealerBodyType,
  DealerResponse,
  OrderedDealersResponse,
  SyncHandcraftOrdeStateEnum,
} from "../../model/types";

export const fetchDealers = createAsyncThunk<
  DealerResponse,
  DealerBodyType,
  { rejectValue: string }
>("dealer/fetchDealers", async (body, { rejectWithValue }) => {
  try {
    const response = await $api.post<DealerResponse>(
      "/dealer",
      JSON.stringify(body),
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});

export const fetchDealerBranches = createAsyncThunk<
  DealerResponse,
  DealerBodyType,
  { rejectValue: string }
>("dealer/fetchDealerBranches", async (body, { rejectWithValue }) => {
  try {
    const response = await $api.post<DealerResponse>(
      "/dealer",
      JSON.stringify(body),
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});

export const fetchOrderedDealers = createAsyncThunk<
  OrderedDealersResponse,
  DealerBodyType,
  { rejectValue: string }
>("dealer/fetchOrderedDealers", async (body, { rejectWithValue }) => {
  try {
    const response = await $api.post<OrderedDealersResponse>(
      "/dealer/prolongation",
      JSON.stringify(body),
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});

const SYNC_POLL_INTERVAL_MS = 5000;

const wait = (ms: number) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });

export const syncHandcraftOrderState = createAsyncThunk<
  SyncHandcraftOrdeStateEnum,
  void,
  { rejectValue: string }
>("dealer/syncHandcraftOrdeState", async (_, { rejectWithValue }) => {
  try {
    const response = await $integrationApi.get<SyncHandcraftOrdeStateEnum>(
      "/sync/handcraft-order/state",
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});

export const waitHandcraftOrdeStateCompleted = createAsyncThunk<
  SyncHandcraftOrdeStateEnum,
  void,
  { rejectValue: string }
>(
  "dealer/waitHandcraftOrdeStateCompleted",
  async (_, { dispatch, rejectWithValue, signal }) => {
    while (!signal.aborted) {
      const result = await dispatch(syncHandcraftOrderState());

      if (syncHandcraftOrderState.rejected.match(result)) {
        return rejectWithValue(
          result.payload ?? "Не удалось получить статус синхронизации корзины",
        );
      }

      const state = result.payload;

      if (state === SyncHandcraftOrdeStateEnum.Started) {
        await wait(SYNC_POLL_INTERVAL_MS);
        continue;
      }

      dispatch(fetchOrderedDealers({}));
      return state;
    }

    return rejectWithValue("Ожидание синхронизации отменено");
  },
);
